import { inject, Provider } from '@angular/core';

import { Cb2PreviewStateService } from '@core/services/cb2-preview/cb2-preview-state.service';

import {
  CART_MERCHANT_AMOUNT_BLOCK_DATA_SOURCE,
  CartMerchantAmountBlockDataSource,
} from './cart-merchant-amount-block-view-model';
import { CartMerchantAmountBlockPreviewDataSource } from './cart-merchant-amount-block-preview-data-source';
import { CartMerchantAmountBlockStoreDataSource } from './cart-merchant-amount-block-store-data-source';

export function provideCartMerchantAmountBlockDataSource(): Provider[] {
  return [
    CartMerchantAmountBlockStoreDataSource,
    CartMerchantAmountBlockPreviewDataSource,
    {
      provide: CART_MERCHANT_AMOUNT_BLOCK_DATA_SOURCE,
      useFactory: (): CartMerchantAmountBlockDataSource => {
        const previewState = inject(Cb2PreviewStateService);
        return previewState.isActive()
          ? inject(CartMerchantAmountBlockPreviewDataSource)
          : inject(CartMerchantAmountBlockStoreDataSource);
      },
    },
  ];
}
